import { jsx as _jsx } from "react/jsx-runtime";
import 'mobx-wrap-request';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { configure } from 'mobx';
import { createRoot } from 'react-dom/client';
import { TSDI } from 'tsdi';
import { routeTree } from './routeTree.gen';
configure({
    enforceActions: 'never',
    useProxies: 'Proxy' in window ? 'always' : 'never'
});
const tsdi = new TSDI();
tsdi.enableComponentScanner();
const router = createRouter({
    routeTree,
    defaultPreload: 'intent'
});
const rootElement = document.getElementById('app');
if (rootElement) {
    const root = createRoot(rootElement);
    root.render(_jsx(RouterProvider, { router: router }));
}
